import { ChangeDetectorRef, Component, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MentorselectComponent } from './mentorselect/mentorselect.component';
import { AiService } from '../../service/ai.service';
import { FormBuilder } from '@angular/forms';
import { AddPinComponent } from './add-pin/add-pin.component';
import { ActivatedRoute, Router } from '@angular/router';
import { TrackService } from '../../service/track.service';

@Component({
  selector: 'app-feedback-card',
  standalone: false,
  templateUrl: './feedback-card.component.html',
  styleUrl: './feedback-card.component.scss'
})
export class FeedbackCardComponent implements OnChanges {

  // Injections
  dialog = inject(MatDialog);
  aiService = inject(AiService);
  fb = inject(FormBuilder);
  route = inject(ActivatedRoute);
  router = inject(Router);
  trackService = inject(TrackService);
  cd = inject(ChangeDetectorRef);

  // Inputs
  @Input({ required: true }) stepId: string = "";
  @Input({ required: true }) streamId: string = "";
  @Input({ required: true }) roundId: string = "";
  @Input({ required: true }) initialReady: boolean = false;

  // Outputs
  @Output() nextStreamStepDisabledStatus: EventEmitter<boolean> = new EventEmitter(true);

  // Variables
  mentorAlert: string = "No Coach is currently assigned. Please select a Coach!";
  currentMentor: any;
  loading: boolean = false;
  messageBoxDisabled: boolean = true;
  recognitionAllowed: boolean = false;
  runningRecignition: boolean = false;
  activeRecognition: any;
  SpeechRecognition: any;
  urlAgentId: any;
  chatInput: string = "";
  currentThreadId: string | undefined;
  ideaCard: any;
  tavilyExtractPrompts: any = {
    "TAVILY_PROMPT_CREATION_COMPETITION": `<ROLE & TASK>
Be a competitor analyst. Analyze the competitor situation for <Idea Card> based on <TAVILY ANSWER> which is from a web search. Build meaningful clusters and conclusions yourself. Name url as sources for every finding! Take your time. Double check.

After analysis is finished suggest the user to a) Summarize conclusion as PINS b) Discuss the analysis further.`,
    "TAVILY_PROMPT_CREATION_MARKET": `<ROLE & TASK>
Be a market analyst. Analyze the market potential for <Idea Card> based on <TAVILY ANSWER> which is from a web search towards your target users. Build meaningful clusters and conclusions yourself. Name sources url! Take your time. Double check.

After analysis is finished suggest the user to a) Summarize conclusion as PINS b) Discuss the analysis further.`
  }

  // Objects
  changedEvents: any[] = [];
  chat: any[] = [];
  feedbackPins: any[] = [];
  currentPins: any[] = [];
  knowledge: any[] = [];
  streamResults: any = [];

  async ngOnChanges(changes: SimpleChanges): Promise<void> {

    if (changes["initialReady"] && changes["initialReady"].currentValue === true) {
      // Get all TrackResults
      let results = this.trackService.trackResults.getValue();
      for await (let item of results) {
        this.knowledge = [...this.knowledge, ...item.stepResults]
      }

      // Get Basic Idea (Idea-Card)
      this.ideaCard = await this.knowledge.find((s: any) => s.stepId == "MMUT2vQla")?.result;

      // Get Pins
      let feedbackCard = await this.knowledge.find((k: any) => k.stepId === this.stepId)?.result;
      if (feedbackCard) {
        this.changedEvents = feedbackCard.changedEvents || [];
        this.feedbackPins = feedbackCard.pins || [];
        this.orderPinsBySession();
      }

      this.urlAgentId = this.route.snapshot.queryParams["agentId"];
      this.SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
      if (this.SpeechRecognition) {
        this.recognitionAllowed = true;
      }
      if (!this.currentMentor) this.openMentorSelect();

      // Set new route without agentId Param
      this.removeAgentIdFromUrl();
    }
  }

  removeAgentIdFromUrl() {
    const { agentId, ...restParams } = this.route.snapshot.queryParams;
    this.urlAgentId = undefined;
    this.router.navigate([this.router.url.split('?')[0]], {
      queryParams: restParams,
      replaceUrl: true
    });
  }

  async runWebSearch() {
    this.loading = true;
    let searchInput = `<USER CONTENT>
    ${JSON.stringify(this.ideaCard)}`
    // Prompt Creation for TAVILY
    let queryString = await this.aiService.getAiStandaloneResponse(this.currentMentor.webSearchId, searchInput);
    // WebSearch With TAVILY
    let webSearchResult = await this.aiService.getAiStandaloneResponse("TAVILY_WEB_SEARCH", queryString.promptResult);

    let input = `<TAVILY ANSWER>
    ${JSON.stringify(webSearchResult.promptResult)}

    ${this.tavilyExtractPrompts[this.currentMentor.webSearchId]}
    `;
    // Analyse with AGent
    let formatting = await this.talkToAgent(true, input)
    this.loading = false;

  }
  async orderPinsBySession(): Promise<true> {
    if (!this.currentMentor) return true;
    this.currentPins = []
    let agentFilter = await this.feedbackPins.filter((p: any) => p.agentId == this.currentMentor.id);

    for await (const p of agentFilter) {
      let exists = await this.currentPins.find((session) => session.sessionId == p.session);
      // console.log(this.currentPins, exists, p);
      if (!exists) {
        this.currentPins.push({
          sessionId: p.session,
          date: new Date(p.dateCreated).toLocaleDateString(),
          pins: [p]
        })
      } else {
        this.currentPins.forEach((p_inner: any) => {
          if (p_inner.sessionId == p.session) {
            p_inner.pins.push(p)
          }
        })
      }
    }

    return true;
  }
  async editPin(pin: any) {
    const dialogRef = this.dialog.open(AddPinComponent, {
      data: { agent: this.currentMentor, edit: true, topic: pin.topic, content: pin.content }
    });

    await dialogRef.afterClosed().subscribe((data) => {
      if (data) {
        pin.topic = data.topic;
        pin.content = data.content;
        data.dateEdited = new Date().getTime();
        data.prio = false;
        this.addChengedEvent("edited");
        this.saveStepResult();
      }
    });
  }
  async priorozePin(pin: any) {
    this.addChengedEvent("priorised");
    for await (let p of this.feedbackPins) {
      if (p == pin) {
        p.prio = !p.prio;
      }
    }
    this.saveStepResult();
  }
  async depriotizePin(pin: any) {
    this.addChengedEvent("depriorised");
    for await (let p of this.feedbackPins) {
      if(p == pin) {
        p.prio = false;
      }
    }
  }
  async deletePin(pin: any) {
    this.addChengedEvent("deleted");
    this.feedbackPins = await this.feedbackPins.filter((p: any) => p !== pin);
    this.saveStepResult();
  }
  async summarizePrompt() {
    if (!this.currentMentor) {
      alert(this.mentorAlert);
      return;
    }
    this.talkToAgent(true, "summarize");
  }
  async talkToAgent(hidden: boolean = false, text: string | undefined = undefined) {
    if (!this.currentMentor) {
      alert(this.mentorAlert);
      return;
    }
    if (this.chatInput == "" && text === undefined) {
      return;
    }
    let userText = text || this.chatInput;
    this.chatInput = "";
    if (hidden === false) {

      this.chat.push({
        type: "user",
        text: userText,
        timestamp: new Date().getTime(),
      })

    }
    this.loading = true;
    let result: any = await this.aiService.feedbackCardConversation(userText, this.currentThreadId);
    this.loading = false;

    if (result && result.threadId) {
      this.currentThreadId = result.threadId;
      this.aiService.threadId = this.currentThreadId;
    }


    if (result && result.message) {
      if (Array.isArray(result.message)) {
        console.log("===== Summarize detected", result.message);

        if (result.message.length !== 0) {
          await result.message.forEach((e: any) => {
            e.agentId = this.currentMentor.id;
            e.mainTag = this.currentMentor?.mainTag;
            e.agentName = this.currentMentor.name;
            e.session = this.aiService.threadId;
            e.dateCreated = new Date().getTime();
            e.prio = false;
            e.source = "SIMPLE-CHAT"

            this.feedbackPins.unshift(e);
          });
          this.addChengedEvent("add");
          this.saveStepResult();
        }

      } else if (result.message.formTransfer) {
        console.log("=====================Formtransfer FOUND");

        if (result.message.formTransfer.length !== 0) {
          await result.message.formTransfer.forEach((e: any) => {
            e.agentId = this.currentMentor.id;
            e.mainTag = this.currentMentor?.mainTag;
            e.agentName = this.currentMentor.name;
            e.session = this.aiService.threadId;
            e.dateCreated = new Date().getTime();
            e.prio = false;
            e.source = "SIMPLE-CHAT";

            this.feedbackPins.unshift(e);
          });
          this.addChengedEvent("add");
          this.saveStepResult();
        }
        this.chat.push({
          type: "agent",
          text: result.message.answer,
          timestamp: new Date().getTime(),
        })
      } else {
        console.log("====== Plain Chat");

        this.chat.push({
          type: "agent",
          text: result.message.answer,
          timestamp: new Date().getTime(),
        })
      }
    }
    this.scrollToBottom();
  }
  async addOwnPin() {
    if (!this.currentMentor) {
      alert(this.mentorAlert);
      return;
    }
    const dialogRef = this.dialog.open(AddPinComponent, {
      data: { agent: this.currentMentor }
    });

    await dialogRef.afterClosed().subscribe((data) => {
      if (data) {
        data.agentId = this.currentMentor?.id;
        data.mainTag = this.currentMentor?.mainTag;
        data.agentName = this.currentMentor?.name;
        data.session = this.aiService.threadId;
        data.dateCreated = new Date().getTime();
        data.prio = false;
        data.source = "MANUALLY-ADDED";

        this.feedbackPins.unshift(data);
        this.addChengedEvent("add");
        this.saveStepResult();
      }
    });
  }
  async resetChat() {
    this.talkToAgent(false, "Reset chat.")
  }
  async exportToMiro() {
    this.loading = true;
    await this.aiService.aiMiroExport(this.currentPins);
    this.loading = false;
  }
  async openMentorSelect() {
    const dialogRef = this.dialog.open(MentorselectComponent, {
      data: { urlAgentId: this.urlAgentId }
    });

    await dialogRef.afterClosed().subscribe(async (data) => {

      if (data) {
        this.messageBoxDisabled = false;
        this.currentMentor = data;
        this.currentMentor.viewName = data.name;
        this.cd.detectChanges();
        console.log("AGENT", this.currentMentor);
        this.aiService.agentId.next(data.id);
        this.aiService.threadId = undefined;
        await this.orderPinsBySession();


        if (this.currentMentor.id === "vali_synthuser") {
          let persona = await this.knowledge.find((k: any) => k.stepId === "Ci6Ju_grd");
          if (persona) {
            console.log(persona);

            this.currentMentor.image = persona.result.image?.split('\'')[1];
            try {
              persona.result = JSON.parse(persona.result);
            } catch (error) {
              // Nothing to do
            }
            this.currentMentor.viewName = persona.result.name;
          }
        }


        this.chat = []
        let infoContent = [];

        // console.log("KNOWLEDGE", this.knowledge);


        for (let i of data.neededDataId) {
          let res = await this.knowledge.find((k: any) => k.stepId === i.id)
          if (res) {
            infoContent.push(`<${i.name}>\n${JSON.stringify(res.result)}`);
          }
        }

        // console.log("Infocontent", infoContent);

        let finalString = "<USER INPUT - Start>"
        if (infoContent.length !== 0) {
          finalString += infoContent
        }

        finalString += `<PINS>\n`
        this.currentPins.forEach((p: any) => {
          p.pins.forEach((pin: any) => {
            finalString += `Topic: ${pin.topic}\nContent: ${pin.content}\n\n`

          });
        })


        finalString += "<USER INPUT - End>\nStart"
        this.talkToAgent(true, finalString)
      } else {
        if (!this.currentMentor) {
          this.messageBoxDisabled = true;
        }
        await this.orderPinsBySession();
      }

    });
  }
  async saveStepResult(): Promise<void> {
    let stepData: any = { "pins": this.feedbackPins, "changedEvents": this.changedEvents }
    await this.trackService.addStepResult(this.roundId, this.streamId, this.stepId, stepData, "Feedback Card");
    this.orderPinsBySession();
  }
  startSpeechRecognition() {
    if (!this.currentMentor) {
      alert(this.mentorAlert);
      return;
    }
    this.activeRecognition = new this.SpeechRecognition();
    this.activeRecognition.lang = 'de-DE';
    this.activeRecognition.continuous = true;
    this.activeRecognition.interimResults = false;
    this.runningRecignition = true;

    this.activeRecognition.onstart = () => {
      console.log('Spracherkennung gestartet...');
    };

    this.activeRecognition.onresult = (event: any) => {
      const transcript = event.results[0][0].transcript;
      this.chatInput = transcript;
    };

    this.activeRecognition.onerror = (event: any) => {
      alert('Fehler bei der Spracherkennung:' + event.error);
      console.error('Fehler bei der Spracherkennung:', event.error);
    };

    this.activeRecognition.onend = () => {
      console.log('Spracherkennung beendet.');
    };

    this.activeRecognition.start();
  }
  stopSpeechRecognition() {
    this.runningRecignition = false;
    this.activeRecognition.stop();
  }
  async addChengedEvent(type: string,) {
    let exists = await this.changedEvents.find(event => event.type === type && event.agentId === this.currentMentor.id);
    if (!exists) {
      this.changedEvents.push({ type, agentId: this.currentMentor.id })
    }
  }
  scrollToBottom(): void {
    try {
      setTimeout(() => {
        const el = document.getElementById("chat-input");
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } catch (err) {
      // Fehlerbehandlung, falls nötig
    }
  }
}
